<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h3 v-if="order.customer.type_document == 'DNI'">Pedidos de {{ order.customer.name }} {{ order.customer.surname }}</h3>
                <h3 v-else>Pedidos de {{ order.customer.name }}</h3>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="4" class="pt-0">
                <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="start_date"
                        label="Fecha de inicio"
                        readonly
                        clearable
                        v-on="on"
                        @click:clear="clearStartDate"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="start_date" @input="menu1 = false" @change="handleChangeStartDate" no-title></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="4" class="pt-0">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="end_date"
                        label="Fecha fin"
                        readonly
                        clearable
                        v-on="on"
                        @click:clear="clearEndDate"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="end_date" @input="menu2 = false" no-title @change="handleChangeEndDate"></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="detail-history pt-0 wost-scroll">
                <v-data-table
                    class="wost-table"
                    :headers="headers"
                    :items="historyFounded"
                    hide-default-footer
                    item-key="id"
                >
                    <template v-slot:item.id="{ item }">
                         #{{ item.id | numberOrder }}
                    </template>

                    <template v-slot:item.entry_time="{ item }">
                        {{ item.entry_time | moment("DD/MM/YYYY, h:mm a") }}
                    </template>

                    <template v-slot:item.delivery_time="{ item }">
                        {{ item.delivery_time | moment("DD/MM/YYYY, h:mm a") }}
                    </template>

                    <template v-slot:item.final_deliveryman="{ item }">
                        <span v-if="item.final_deliveryman">
                            {{ item.deliveryend.first_name }} {{ item.deliveryend.last_name }}
                        </span>
                    </template>

                    <template v-slot:item.status="{ item }">
                        <span :class="'order-status order-status-' + item.status.toLowerCase().replace(' ', '-')">
                            {{ item.status | uppercase }}
                        </span>
                    </template>

                    <template v-slot:item.total="{ item }">
                        <span>
                            {{ item.total | currency('S/') }}
                        </span>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

    </v-container>    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'History',
    computed: {
        ...mapState('orders', [
            'order',
            'history',
            'historyFounded'
        ]),        
    },
    data() {
        return {
            search: '',
            date: new Date().toISOString().substr(0, 10),
            start_date: null,
            end_date: null,
            menu1: false,
            menu2: false,
            headers: [
                { text: 'Número', value: 'id', align: 'left', sortable: false, class: 'header-table-history', width: 60},
                { text: 'F. de Pedido', value: 'entry_time', align: 'left', sortable: false, class: 'header-table-history', width: 140},
                { text: 'F. de Entrega', value: 'delivery_time', align: 'left', sortable: false, class: 'header-table-history', width: 140 },                
                { text: 'Repartidor', value: 'final_deliveryman', align: 'left', sortable: false, class: 'header-table-history', width: 120 },
                { text: 'Estado', value: 'status', align: 'left', sortable: false, class: 'header-table-history', width: 80 },
                { text: 'Total', value: 'total', align: 'left', sortable: false, class: 'header-table-history', width: 80 }
            ],
        }
    },
    methods: {
        ...mapActions('orders', [
            'selectOrder',
            'getHistory'
        ]),
        clearStartDate(){
            this.start_date = null
            if(this.end_date == null){
                let params = {
                    option: 'customer',
                    customer_id: this.order.customer_id
                }
                this.getHistory(params) 
            }else{
                let params = {
                    option: 'one_date',
                    customer_id: this.order.customer_id,
                    date: this.end_date
                }
                this.getHistory(params) 
            }
        },
        handleChangeStartDate(value){
            if (this.end_date == null) {
                let params = {
                    option: 'one_date',
                    customer_id: this.order.customer_id,
                    date: value
                }
                this.getHistory(params)                
            } else {
                 let params = {
                    option: 'two_date',
                    customer_id: this.order.customer_id,
                    start_date: this.start_date,
                    end_date: this.end_date
                }
                this.getHistory(params) 
            }
        },
        clearEndDate(){
            this.end_date = null
            if(this.start_date == null){
                let params = {
                    option: 'customer',
                    customer_id: this.order.customer_id
                }
                this.getHistory(params) 
            }else{
                let params = {
                    option: 'one_date',
                    customer_id: this.order.customer_id,
                    date: this.start_date
                }
                this.getHistory(params) 
            }
        },
        handleChangeEndDate(value) {
            if (this.start_date == null) {
                let params = {
                    option: 'one_date',
                    customer_id: this.order.customer_id,
                    date: value
                }
                this.getHistory(params)                
            } else {
                 let params = {
                    option: 'two_date',
                    customer_id: this.order.customer_id,
                    start_date: this.start_date,
                    end_date: this.end_date
                }
                this.getHistory(params) 
            }
        }
    }
}
</script>

<style>
.header-table-history{
    background-color: #3F51B5 !important;
    color: #ffffff !important;
    text-transform: uppercase;
    height: 50px !important;
    line-height: 30px;
}

.detail-history{
    height: 45vh;
    overflow-y: auto;
}
</style>